import { motion } from "framer-motion";
import {
  SunShape,
  CloudShape,
  Tree,
  Cone,
  TrafficLight,
  LPlateSign,
  PinPoint,
  ArrowSign,
  CarBody,
  Sparkle,
} from "./parts";

export const HeroScene = () => (
  <div
    data-testid="hero-illustration"
    className="relative overflow-hidden rounded-3xl border border-slate-200/80 bg-[#EAF3FF] shadow-xl shadow-blue-600/5"
  >
    <svg
      viewBox="0 0 600 560"
      className="h-[420px] w-full md:h-[520px]"
      role="img"
      aria-label="Cartoon illustration of a blue learner car driving along a winding road past traffic signs"
    >
      <g transform="translate(505 95)">
        <motion.g
          animate={{ rotate: 360 }}
          transition={{ duration: 70, repeat: Infinity, ease: "linear" }}
        >
          <SunShape />
        </motion.g>
      </g>
      <g transform="translate(130 85)">
        <motion.g
          animate={{ x: [0, 18, 0] }}
          transition={{ duration: 9, repeat: Infinity, ease: "easeInOut" }}
        >
          <CloudShape />
        </motion.g>
      </g>
      <g transform="translate(345 55) scale(0.7)">
        <motion.g
          animate={{ x: [0, -14, 0] }}
          transition={{ duration: 12, repeat: Infinity, ease: "easeInOut" }}
        >
          <CloudShape />
        </motion.g>
      </g>

      <ellipse cx="90" cy="530" rx="250" ry="95" fill="#BBF7D0" />
      <ellipse cx="540" cy="540" rx="270" ry="105" fill="#A7F3D0" />

      <path d="M-20 500 C 140 452 320 538 620 468 L 620 560 L -20 560 Z" fill="#64748B" />
      <path d="M-20 500 C 140 452 320 538 620 468" fill="none" stroke="#F8FAFC" strokeWidth="4" />
      <path
        className="road-dash"
        d="M-20 531 C 140 483 320 569 620 499"
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="6"
        strokeDasharray="26 30"
        strokeLinecap="round"
      />

      <TrafficLight x={30} y={245} />
      <ArrowSign x={128} y={300} />
      <Tree x={558} y={415} scale={1.05} />
      <LPlateSign x={488} y={262} />
      <PinPoint x={452} y={208} />
      <Cone x={408} y={478} />
      <Cone x={452} y={492} />

      <g transform="translate(168 382)">
        <motion.g
          animate={{ y: [0, -4, 0] }}
          transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }}
        >
          <CarBody />
        </motion.g>
      </g>

      <Sparkle x={80} y={150} />
      <Sparkle x={270} y={110} delay={0.8} />
      <Sparkle x={540} y={180} delay={1.4} />
    </svg>
  </div>
);
